import validate from "/srv/www/uia-frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/srv/www/uia-frontend/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  access: () => import("/srv/www/uia-frontend/middleware/access.js"),
  auth: () => import("/srv/www/uia-frontend/middleware/auth.js"),
  breadcrumbs: () => import("/srv/www/uia-frontend/middleware/breadcrumbs.js"),
  contribution: () => import("/srv/www/uia-frontend/middleware/contribution.js")
}